import { createFileRoute } from '@tanstack/react-router'
import LazyRoute from '@/components/LazyRoute'

export const Route = createFileRoute('/_protected/organization/settings/notifications')({
  component: () => (
    <LazyRoute
      loader={() => import('@/components/organization-settings/notifications')}
      fallback={<div>Loading...</div>}
    />
  ),
})